'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createForm = exports.storage = exports.attribution = undefined;

var _attribution = require('./lib/attribution');

var attribution = _interopRequireWildcard(_attribution);

var _storage = require('./lib/storage');

var storage = _interopRequireWildcard(_storage);

var _forms = require('./lib/forms');

var _forms2 = _interopRequireDefault(_forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// setup attribution tracking
attribution.setLandingTimestamp();
attribution.setLandingURL();

exports.attribution = attribution;
exports.storage = storage;
exports.createForm = _forms2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@morgan-morgan/core/module/index.js
// module id = 11
// module chunks = 2 3